export default __webpack_public_path__ + "static/media/img-1.426295a4.jpg";